import { useInfiniteQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import type { StoriesPage } from "../../@types/portalAluno";
import { PORTAL_STORIES_PAGE_SIZE } from "../../config/portalAluno/constants";
import { getStoriesPage } from "../../services/portalAluno/stories/storiesService";
import type { ApplicationState } from "../../store";

export const portalStoriesQueryKey = (idUsuario?: number) => [
  "portal-aluno",
  "storys",
  idUsuario,
];

const useHomeStories = () => {
  const auth = useSelector((state: ApplicationState) => state.auth.data);
  const idUsuario = auth?.idUsuario;

  return useInfiniteQuery<StoriesPage>({
    enabled: Boolean(idUsuario),
    queryKey: portalStoriesQueryKey(idUsuario),
    queryFn: ({ pageParam = 0 }) => getStoriesPage(pageParam),
    getNextPageParam: (lastPage, allPages) =>
      lastPage.itemCount < PORTAL_STORIES_PAGE_SIZE
        ? undefined
        : allPages.length * PORTAL_STORIES_PAGE_SIZE,
  });
};

export default useHomeStories;
